import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/mobile-device-risk-check/RiskCheckClient.tsx");
